import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MonitoringService } from '../../../core/services/monitoring/legal-entity-client/monitoring.service'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { IndividualClientService } from '../../../core/services/monitoring/individual-client/individual-client.service'
import { NgxMaskDirective } from 'ngx-mask'
import { AddressClientEditComponent } from '../../address/address-client-edit/address-client-edit.component'
import { ContactClientEditComponent } from '../../contact/contact-client-edit/contact-client-edit.component'
import { TaxDocumentClientEditComponent } from '../../tax-document/tax-document-client-edit/tax-document-client-edit.component'
import { PaymentMethodsClientEditComponent } from '../../payment/payment-client-edit/payment-methods-client-edit.component'
import { BankDetailsClientEditComponent } from '../../bank/bank-details-client-edit/bank-details-client-edit.component'
import { ConsultantClientEditComponent } from '../../person/consultant-client-edit/consultant-client-edit.component'
import { PersonLegalService } from '../../../core/services/person/person-legal/person-legal.service'
import { ExamRelationPatientEditComponent } from '../../exam/exam-relation-patient-edit/exam-relation-patient-edit.component'
import { AssociateSubClientCreateComponent } from '../patient-create/associate-sub-client-create/associate-sub-client-create.component'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { DecimalInputDirective } from '../../../shared/directives/decimalInput'
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle'
import { convertCurrency } from '../../../shared/utils/utils'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ResponsibleClientEditComponent } from '../../person/responsible-client-edit/responsible-client-edit.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import {HealthUnitService} from '../../../core/services/health-unit/location/health-unit.service';
import {HabitsService} from '../../../core/services/employee/employee-role/habits.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {AlertPatientCreateComponent} from '../../alert/alert-patient-create/alert-patient-create.component';
import {
  AlertPatientEditComponent
} from '../../alert/alert-patient-edit/alert-patient-edit/alert-patient-edit.component';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {
  MedicalInsurancePatientEditComponent
} from '../../medical-insurance/medical-insurance-patient/alert-patient-edit/alert-patient-edit/medical-insurance-patient-edit.component';
import {PreviousDiseasesService} from '../../../core/services/previousDiseases/diseases/previous-diseases.service';

@Component({
  selector: 'patient-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    AddressClientEditComponent,
    ContactClientEditComponent,
    ExamRelationPatientEditComponent,
    DecimalInputDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatCheckbox,
    AlertPatientEditComponent,
    AlertPatientEditComponent,
    MedicalInsurancePatientEditComponent,
  ],
  templateUrl: './patient-edit.component.html',
  styleUrl: './patient-edit.component.scss',
  providers: [
    PersonLegalService,
    IndividualClientService,
    CommissionDividerService,
  ],
  standalone: true,
})
export class PatientEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private legalEntityClientService: MonitoringService,
    private commissionDividerService: CommissionDividerService,
    private individualClientService: IndividualClientService,
    private unidadeSaudeService: HealthUnitService,
    private municipalityService: MunicipalityService,
    private habitoService: HabitsService,
    private previousDiseasesService: PreviousDiseasesService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<PatientEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
  }

  @Output() response = new EventEmitter()
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined

  healthForm: FormGroup = new FormGroup({})
  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
  ]

  listaMunicipios: any = []
  listaUnidades: any = []
  listaHabitos: any = []
  listaDoencas: any = []

  typeClient: 'legal' | 'individual' = 'legal'
  item: any
  loading: boolean = false
  loadingScreen: boolean = true
  addressClient: any = {}
  addressList: any[] = []
  contactList: any[] = []
  taxDocumentList: any[] = []
  paymentMethodsList: any[] = []
  bankDetailsList: any[] = []
  consultantList: any[] = []
  tariffList: any[] = []
  subClientList: any[] = []
  responsibleList: any[] = []
  alertList: any[] = []
  isSelectHealthUnitActive: boolean = false
  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  ngOnInit(): void {
    this.createForm()
    this.getCommissionDivider()
    this.getHabitos()
    this.getDoencas()
    this.loadingScreen = false
    this.addressClient = this.item?.endereco
    this.getMunicipio()
    this.getUnidadesSaude(this.item?.municipio_id)
  }
  getMunicipio(){
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if(response.data){
          this.listaMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  onMunicipioChange() {
    const municipioId = this.formLegalEntity.get('municipality')?.value;

    this.formLegalEntity.get("healthUnit")?.reset();

    if (municipioId !== 0) {
      this.isSelectHealthUnitActive = true;
      this.formLegalEntity.get('healthUnit')?.enable();
      this.getUnidadesSaude(municipioId);

    } else {
      this.isSelectHealthUnitActive = false;
      this.formLegalEntity.get('healthUnit')?.disable();


    }
  }
  openDatepicker() {
    if (this.datepicker) this.datepicker.open()
  }
  getDoencas() {
    this.loading = true
    this.previousDiseasesService.listDiseases().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listaDoencas = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  getUnidadesSaude(idMunicip: number | null = null){
    this.loading = true
    console.log(idMunicip);
    if(idMunicip == null){
      this.unidadeSaudeService
        .listActiveLocation()
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.listaUnidades = response.data
          },
          error: (err: ErrorRequestModel) => {
            this.loading = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loading = false
          },
        })
    } else{
      this.unidadeSaudeService
        .listActiveLocationByMunicip(idMunicip)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.listaUnidades = response.data
          },
          error: (err: ErrorRequestModel) => {
            this.loading = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loading = false
          },
        })
    }
  }

  getHabitos() {
    this.habitoService.listHabits().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listaHabitos = response.data
      },
      error: (err: ErrorRequestModel) => this.snackbar.errorRequest(err),
    })
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    console.log("item: ", this.item)
    this.formLegalEntity = this.formBuilder.group({
      municipality: [this.item?.municipio_id, [Validators.required]],
      name: [this.item?.nomeCompleto ?? '', [Validators.required]],
      email: [this.item?.email ?? '', [Validators.required]],
      phone: [this.item?.telefone_whatsapp?.slice(2) ?? this.item?.telefone_1?.slice(2) ?? '', [Validators.required]],
      birth: [this.item?.data_nascimento ?? '', [Validators.required]],
      cpf: [this.item?.cpf ?? '', [Validators.required]],
      healthUnit: [Number(this.item?.unidade_id) ?? 0, [Validators.required]],
      rg: [this.item?.rg ?? '', [Validators.required]],
      password: ['••••••', [Validators.required]], // não obriga na edição
      maritalStatus: [Number(this.item?.estado_civil) ?? null, [Validators.required]],
      sex: [this.item?.genero ?? 0, [Validators.required]],
      consentForm: [this.item?.consentimento_aceito == '1', [Validators.required]],
    })
    this.healthForm = this.formBuilder.group({
      height: [this.item?.altura ?? '', [Validators.required]],
      weight: [this.item?.peso ?? '', [Validators.required]],
      habits: [
        this.item?.habitos?.map((h: any) => (h.habito_id)) ?? [],
      ],
      previousDiseases: [this.item?.doencas?.map((h: any) => (h.doenca_id)) ?? []],
      history: [this.item?.historico_clinico ?? '', [Validators.required]], // aqui o nome correto
    })

  }

  checkInvalidForm() {
    return (
      this.formLegalEntity.invalid ||
      this.loading ||
      this.healthForm.invalid
    )
  }

  editLegalModel() {
    return {
      id: this.item?.paciente_id,
      nomeCompleto: this.formLegalEntity.get('name')?.value ?? '',
      telefone_1: ("55"+this.formLegalEntity.get('phone')?.value),
      telefone_whatsapp: ("55"+this.formLegalEntity.get('phone')?.value),
      email: this.formLegalEntity.get('email')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
      data_nascimento: this.formLegalEntity.get('birth')?.value ?? '',
      unidade_id: this.formLegalEntity.get('healthUnit')?.value ?? 0,
      rg: this.formLegalEntity.get('rg')?.value ?? '',
      genero: this.formLegalEntity.get('sex')?.value ?? '',
      senha: this.formLegalEntity.get('password')?.value === '••••••' ? null : this.formLegalEntity.get('password')?.value ?? '',
      estado_civil: this.formLegalEntity.get('maritalStatus')?.value ?? '',
      consentimento_aceito: this.formLegalEntity.get('consentForm')?.value ?? false,
      altura: Number(String(this.healthForm.get('height')?.value).replace(',', '.')) || 0,
      peso: Number(String(this.healthForm.get('weight')?.value).replace(',', '.')) || 0,
      habito_id: this.healthForm.get('habits')?.value ?? [],
      historico_paciente: this.healthForm.get('history')?.value ?? '',
      doenca_id: Array.isArray(this.healthForm?.get('previousDiseases')?.value)
        ? this.healthForm?.get('previousDiseases')?.value
        : this.healthForm?.get('previousDiseases')?.value
          ? [this.healthForm?.get('previousDiseases')?.value]
          : [],
    }
  }

  editPatient() {
    this.loading = true
    this.legalEntityClientService.editLegalEntityClient(this.editLegalModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: any) => {
        this.loading = false
        this.snackbar.error(err.error.message)
      },
      complete: () => {
        this.loading = false
        this.formLegalEntity.reset()
        this.formFinancial.reset()
      },
    })
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) this.fillFormFinancial()
    else this.fillFormFinancial(true)
  }

  fillFormFinancial(clear: boolean = false) {
    if (!clear) {
      this.formFinancial.get('divider')?.setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial.get('tax')?.setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial.get('commission')?.setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')?.disable()
      this.formFinancial.get('tax')?.disable()
      this.formFinancial.get('commission')?.disable()
    } else {
      this.formFinancial.get('divider')?.enable()
      this.formFinancial.get('tax')?.enable()
      this.formFinancial.get('commission')?.enable()
    }
  }
  verifyCreate(){
    if(this.checkInvalidForm() || this.tariffList.length > 0 || this.contactList.length > 0 || this.alertList.length > 0){
      // this.editMonitoring()
    }
    else{
      // this.editPatient()
    }
  }
  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa: response.data.taxa,
          divisor: response.data.divisor,
          comissao: response.data.comissao,
        }
        this.fillFormFinancial()
      },
      error: (err: ErrorRequestModel) => console.error('err', err),
    })
  }
}
